import React, {Component} from 'react';
import ReactDOM from 'react-dom';
import PropTypes from 'prop-types';
import {Overlay, ModalContainer, CloseButton, Title} from './styled';
import {Typography} from "@material-ui/core";

class ModalComponent extends Component {
    constructor(props) {
        super(props);
        this.el = document.createElement('div');
    }

    componentDidMount() {
        document.body.appendChild(this.el);
    }

    componentWillUnmount() {
        document.body.removeChild(this.el);
    }

    render() {
        const {isOpen, onClose, children, title, fullWidth} = this.props;

        if (!isOpen) return null;

        return ReactDOM.createPortal(
            <Overlay onClick={onClose}
                     zIndex={this.props.zIndex}>
                <ModalContainer onClick={(e) => e.stopPropagation()}
                                maxWidth={this.props.maxWidth}
                                maxHeight={this.props.maxHeight}
                                withOverflowY={this.props.withOverflowY}
                                fullWidth={fullWidth}> {/* Repassando a prop aqui */}
                    <CloseButton onClick={onClose}>&times;</CloseButton>
                    {title && <Typography variant={'h5'}
                                          color={'textPrimary'}>{title}</Typography>}
                    <div>
                        {children}
                    </div>
                </ModalContainer>
            </Overlay>,
            this.el
        );
    }
}

ModalComponent.propTypes = {
    isOpen: PropTypes.bool.isRequired,
    onClose: PropTypes.func.isRequired,
    children: PropTypes.node,
    title: PropTypes.string,
    maxWidth: PropTypes.number,
    maxHeight: PropTypes.number,
    withOverflowY: PropTypes.bool,
    zIndex: PropTypes.number,
    fullWidth: PropTypes.bool, // Adicionado no propTypes
};

export default ModalComponent;